import {NavigationPageEnum, NavigationPageEnumHumanReadable} from '../../navigations.enums';
import {IUserAccessFeature, IUserAccessSubFeatures} from '../user-access-features';
import {SettingsReferenceEnum} from '../../../../settings-new/models';
import {IUserAccessFeatureAutoOrderingSettings} from '../access';

//#region INTERFACE IFeatureAutoOrderingGeneralSettings
export interface IFeatureAutoOrderingGeneralSettings extends IUserAccessFeature, IUserAccessSubFeatures, Object {
}

//#endregion

//#region CONST _FEATURE_AUTO_ORDERING_GENERAL_SETTINGS_DEFAULT
export const _FEATURE_AUTO_ORDERING_GENERAL_SETTINGS_DEFAULT: Readonly<IFeatureAutoOrderingGeneralSettings & Object> = {
  displayText: NavigationPageEnumHumanReadable.AutoOrderingGeneralSettings,
  feature: NavigationPageEnum.AutoOrderingGeneralSettings,
  ref: SettingsReferenceEnum.featureAutoOrderGeneralSettings,
  standalone: true,
};
//#endregion


//#region INTERFACE IFeatureAutoOrderingOpenOrderSettings
export interface IFeatureAutoOrderingOpenOrderSettings extends IUserAccessFeature, IUserAccessSubFeatures, Object {
}

//#endregion

//#region CONST _FEATURE_AUTO_ORDERING_OPEN_ORDER_SETTINGS_DEFAULT
export const _FEATURE_AUTO_ORDERING_OPEN_ORDER_SETTINGS_DEFAULT: Readonly<IFeatureAutoOrderingOpenOrderSettings & Object> = {
  displayText: NavigationPageEnumHumanReadable.AutoOrderingOpenOrderSettings,
  feature: NavigationPageEnum.AutoOrderingOpenOrderSettings,
  ref: SettingsReferenceEnum.featureAutoOrderOpenOrderSettings,
  standalone: true,
};
//#endregion


//#region INTERFACE IFeatureAutoOrderingOrderSettings
export interface IFeatureAutoOrderingOrderSettings extends IUserAccessFeature, IUserAccessSubFeatures, Object {
}

//#endregion

//#region CONST _FEATURE_AUTO_ORDERING_ORDER_SETTINGS_DEFAULT
export const _FEATURE_AUTO_ORDERING_ORDER_SETTINGS_DEFAULT: Readonly<IFeatureAutoOrderingOrderSettings & Object> = {
  displayText: NavigationPageEnumHumanReadable.AutoOrderingOrderSettings,
  feature: NavigationPageEnum.AutoOrderingOrderSettings,
  ref: SettingsReferenceEnum.featureAutoOrderOrderSettings,
  standalone: true,
};
//#endregion


//#region INTERFACE IFeatureAutoOrderingGeneralSettings
export interface IFeatureAutoOrderingSchedulerSettings extends IUserAccessFeature, IUserAccessSubFeatures, Object {
}

//#endregion

//#region CONST _FEATURE_AUTO_ORDERING_GENERAL_SETTINGS_DEFAULT
export const _FEATURE_AUTO_ORDERING_SCHEDULER_SETTINGS_DEFAULT: Readonly<IFeatureAutoOrderingSchedulerSettings & Object> = {
  displayText: NavigationPageEnumHumanReadable.AutoOrderingOrderSchedulerSettings,
  feature: NavigationPageEnum.AutoOrderingOrderSchedulerSettings,
  ref: SettingsReferenceEnum.featureAutoOrderSchedulerSettings,
  standalone: true,
};
//#endregion


export interface IFeatureAutoOrderingDocumentLayouts extends IUserAccessFeature, IUserAccessSubFeatures, Object {
}

export const _FEATURE_AUTO_ORDERING_DOCUMENT_LAYOUTS_DEFAULT: Readonly<IFeatureAutoOrderingDocumentLayouts & Object> = {
  displayText: NavigationPageEnumHumanReadable.AutoOrderingDocumentLayouts,
  feature: NavigationPageEnum.AutoOrderingDocumentLayouts,
  ref: SettingsReferenceEnum.featureAutoOrderDocumentLayouts,
  standalone: true,
};

//#region INTERFACE IFeatureAutoOrdering
export interface IFeatureAutoOrdering extends IUserAccessFeature, Object {
  crudAccess: { [storeId: string]: IUserAccessFeatureAutoOrderingSettings };
}

//#endregion

//#region CONST _FEATURE_AUTO_ORDERING_DEFAULT
export const _FEATURE_AUTO_ORDERING_DEFAULT: Readonly<IFeatureAutoOrdering & Object> = {
  displayText: NavigationPageEnumHumanReadable.AutoOrdering,
  feature: NavigationPageEnum.AutoOrdering,
  ref: SettingsReferenceEnum.featureAutoOrder,
  standalone: false,
  subFeatures: [
    {..._FEATURE_AUTO_ORDERING_GENERAL_SETTINGS_DEFAULT},
    {..._FEATURE_AUTO_ORDERING_OPEN_ORDER_SETTINGS_DEFAULT},
    {..._FEATURE_AUTO_ORDERING_DOCUMENT_LAYOUTS_DEFAULT},
  ],
  crudAccess: {},
};
//#endregion
